<label class="form-control-check">
  <input class="form-input"
         type="checkbox"
         [disabled]="isDisabled"
         [checked]="value"
         [ngModel]="value"
         (ngModelChange)="change($event)"
  >
  <span class="form-label" [innerHtml]="label | translate"></span>
</label>

